import { Navigate } from "react-router-dom";
import { useUserContext } from "../stores/userContext";
import { useLocalization } from "../stores/localizationContext";
import { type ReactNode } from "react";

type PrivateRouteProps = {
  children: ReactNode;
};

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isAuthenticated } = useUserContext();
  const { lang } = useLocalization();

  if (!isAuthenticated) {
    return <Navigate to={`/${lang}/signinemail`} replace />;
  }

  return <>{children}</>;
};
